import { Injectable } from '@angular/core';
import { ScheduleBranchDays } from '@app/shared/models/schedule-branch-days.model';
import { HttpService } from '@app/core/services/http/http.service';
import { URLParamsService } from '@app/shared/services/url-params.service';
import { ScheduleNewBranchDays } from '@app/shared/models/schedule-new-branch-day.model';
import { Observable } from 'rxjs';

@Injectable()
export class ScheduleBranchService {
  static readonly url = 'ScheduledBranchs/';

  constructor(private httpService: HttpService) { }

  get(BranchID: number, pageSize: number = 10): Observable<ScheduleBranchDays[]> {
    if (!BranchID) {
      return;
    }
    const url = URLParamsService.buildUrl(
      `${ScheduleBranchService.url}GetScheduledDaysForBranch`,
      {
        BranchID: BranchID,
        pageSize: pageSize
      }
    );

    return this.httpService.GetRequest<ScheduleBranchDays[]>(
      url
    );
  }

  save(schedule: ScheduleNewBranchDays): Observable<ScheduleBranchDays> {
    const url = `${ScheduleBranchService.url}SaveScheduledDaysForBranch`;

    if (schedule.ID) {
      return this.update(schedule);
    }

    return this.httpService.PostRequest<
      ScheduleBranchDays,
      ScheduleNewBranchDays
    >(url, schedule);
  }

  update(schedule: ScheduleNewBranchDays): Observable<ScheduleBranchDays> {
    const url = `${ScheduleBranchService.url}UpdateScheduledDaysForBranch`;

    return this.httpService.PutRequest<
      ScheduleBranchDays,
      ScheduleNewBranchDays
    >(url, schedule);
  }
}
